var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-root"},[_c('div',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"id":"map-container"}})])
}]

export { render, staticRenderFns }